// 配置国际化

import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import locale from "element-ui/lib/locale";
import zh from "./zh";
import en from "./en";
import store from "@/store";

Vue.use(VueI18n);

const messages = {
  zh: {
    ...zh,
    ...zhLocale
  },
  en: {
    ...en,
    ...enLocale
  }
}

// 获取存储语言或者浏览器语言
const preferedLang = store.state.lang;
let lang = preferedLang || ((navigator.language || navigator.browserLanguage).indexOf("en") == 0 ? "en" : ((navigator.language || navigator.browserLanguage) == "zh" || (navigator.language || navigator.browserLanguage) == "zh-CN") ? "zh" : "en");

// 创建i18n实例，并为其指定语言
const i18n = new VueI18n({
  messages,
  locale: lang,
  silentTranslationWarn: true
});

// element-ui 语言动态切换
locale.i18n((key, value)=>i18n.t(key, value));

export default i18n;
